import type { ReactNode } from 'react';
import { Grid, Text } from '@simplywallst/ui-core';

import { DescriptionDetails } from './styled';

type Props = {
  term: string;
  detail: NonNullable<ReactNode>;
  'data-cy-id'?: string;
};

export const Metric = ({ term, detail, 'data-cy-id': dataCyId }: Props) => (
  <Grid
    data-cy-id={dataCyId}
    templateRows="auto auto"
    templateColumns="max-content"
    gap="2px"
  >
    <dt>
      <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
        {term}
      </Text>
    </dt>
    <DescriptionDetails>
      <Text typography="xSmall">{detail}</Text>
    </DescriptionDetails>
  </Grid>
);
